import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

const NotFound = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeRedirect = () => {
        // Divide a URL atual para tentar encontrar o tenant
        // Ex: /nome-empresa/pagina-errada -> ['', 'nome-empresa', 'pagina-errada']
        const pathParts = location.pathname.split('/');
        const currentTenant = pathParts[1]; // Pega o primeiro segmento da URL

        if (currentTenant && currentTenant !== '404') {
            // Mantém o tenant e volta para a página inicial DA CONTA (InnerRoutes decide:
            // Home, ou o primeiro item do menu quando a conta não tem Home — o plano
            // LEITE abre em /propriedade). Fixo em /home, virava um 404 em loop.
            navigate(`/${currentTenant}`);
        } else {
            // Fallback: Se não conseguir identificar o tenant, vai para a raiz
            navigate('/');
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                textAlign: 'center',
            }}
        >
            <Typography
                variant="h1"
                color="primary"
                sx={{ fontWeight: 'bold' }}
            >
                404
            </Typography>
            <Typography variant="h5" sx={{ mb: 2 }}>
                Página não encontrada
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
                Opa! Parece que essa página não existe ou foi movida.
            </Typography>
            <Button
                variant="contained"
                color="primary"
                onClick={handleHomeRedirect}
            >
                Voltar para o início
            </Button>
        </Box>
    );
};

export default NotFound;